import React, {useContext} from "react"
import {RouteDetailContext} from "./context/RouteDetailContext";
import CartContentV2 from "./CartContentV2";
import Column from "@amzn/meridian/column";
import {CapabilityContext} from "../global/context/CapabilityContext";
import PicklistDetailView from "./PicklistDetailView";
import {AR_V2} from "../util/Constants";
import CartContent from "./CartContent";
import RefreshTimer from "../util/RefreshTimer";

const RouteContent = () => {
    const {viewModelRD} = useContext(RouteDetailContext)
    const {configViewModel} = useContext(CapabilityContext)
    const stationConfig = configViewModel.stationConfig;

    const renderContainer = (container, index) => {
        if (configViewModel.capability === AR_V2) {
            return <CartContent key={container.name} index={index} container={container}/>
        } else {
            return <CartContentV2 key={container.name} index={index} container={container}/>
        }
    }
    const renderRouteContainers = () => {
        return viewModelRD.containers.map((container, index) => renderContainer(container, index));
    }

    return (
        <Column widths="100%" spacingInset="medium large large large">
            <RefreshTimer deps={viewModelRD}/>
            {(stationConfig.parallelPickEnabled || stationConfig.routeDetailsTabViewEnabled) ? <PicklistDetailView/> : renderRouteContainers()}
        </Column>
    )
}

export default RouteContent


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/RouteContent.js